import { render, staticRenderFns } from "./modifyPageNotesComponent.vue?vue&type=template&id=3c7b5d70&"
import script from "./modifyPageNotesComponent.vue?vue&type=script&lang=js&"
export * from "./modifyPageNotesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports